export const GET_INFO = 'AUTH/GET_INFO';
export const GET_INFO_PENDING = `${GET_INFO}_PENDING`;
export const GET_INFO_FULFILLED = `${GET_INFO}_FULFILLED`;
export const GET_INFO_REJECTED = `${GET_INFO}_REJECTED`;

export const getInfo = () => ({
  type: GET_INFO,
});

export const UPDATE_INFO = 'USER/UPDATE_INFO';
export const UPDATE_INFO_PENDING = `${UPDATE_INFO}_PENDING`;
export const UPDATE_INFO_FULFILLED = `${UPDATE_INFO}_FULFILLED`;
export const UPDATE_INFO_REJECTED = `${UPDATE_INFO}_REJECTED`;

export const updateInfo = ({ firstName, lastName }) => ({
  type: UPDATE_INFO,
  payload: {
    firstName,
    lastName,
  },
});

export const GENERATE_API_KEY = 'USER/GENERATE_API_KEY';
export const GENERATE_API_KEY_PENDING = `${GENERATE_API_KEY}_PENDING`;
export const GENERATE_API_KEY_FULFILLED = `${GENERATE_API_KEY}_FULFILLED`;
export const GENERATE_API_KEY_REJECTED = `${GENERATE_API_KEY}_REJECTED`;

export const generateApiKey = () => ({
  type: GENERATE_API_KEY,
});

export const CANCEL_ACTIVE_SUB = 'USER/CANCEL_ACTIVE_SUB';
export const CANCEL_ACTIVE_SUB_PENDING = `${CANCEL_ACTIVE_SUB}_PENDING`;
export const CANCEL_ACTIVE_SUB_REJECTED = `${CANCEL_ACTIVE_SUB}_REJECTED`;

export const cancelActiveSub = () => ({
  type: CANCEL_ACTIVE_SUB,
});
